import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentTimeline {
    constructor() {

        this.section = document.querySelector('.component-timeline')

        this.slider = this.section.querySelector(".swiper--component-timeline")
        this.sliderImages = this.section.querySelector('.swiper--component-timeline-images')
        this.navigationPrev = this.section.querySelector(".slider-button-prev--component-timeline")
        this.navigationNext = this.section.querySelector(".slider-button-next--component-timeline")
        this.pagination = this.section.querySelector(".slider-pagination--component-timeline")

        this.imageSlider = document.getElementById('pictureSlider')
        this.imageSliderMobile = document.getElementById('pictureSliderMobile')

        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
            pagination: {
                el: this.pagination,
                clickable: true,
                type: "fraction",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
                1024: {
                  slidesPerView: 1.3,
                  spaceBetween: 30,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 150,
                },
                1600: {
                  slidesPerView: 1.3,
                  spaceBetween: 30,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 150,
                },
            },
        })

        swiper.on('slideChange', () => {
            const imagedesktop = swiper.slides[swiper.realIndex].dataset.imagedesktop
            const imagemobile = swiper.slides[swiper.realIndex].dataset.imagemobile

            this.imageSlider.classList.add('hiddenImage')
            
            setTimeout(() => {
                this.imageSlider.src = imagedesktop
                this.imageSliderMobile.src = imagemobile
            }, 200);
            
            setTimeout(() => {
                this.imageSlider.classList.remove('hiddenImage')
            }, 500);
            

        })

    }
}